import React from 'react'
import styled from 'styled-components'
import { css, media, colors } from 'styles'

export const StyledHamburgerButton = styled.div`
  display: none;
  position: absolute;
  top: 1rem;
  right: 0;
  padding: 1.5rem;
  width: 3.3rem;
  z-index: 8;

  span {
    position: relative;
    display: block;
    z-index: 1;
    width: 100%;
    height: 0.4rem;
    margin-bottom: 0.5rem;
    border-radius: 0.3rem;
    background-color: ${colors.mainInverted};
    -webkit-touch-callout: none;

    transform-origin: 0.4rem 0.5rem;
    transition: transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1), background 0.5s cubic-bezier(0.77, 0.2, 0.05, 1),
      opacity 0.55s ease;
  }

  span:first-child {
    transform-origin: 0% 0%;
  }

  ${p =>
    p.isOpen &&
    css`
      position: fixed;

      span:nth-of-type(1) {
        transform: rotate(45deg);
      }

      span:nth-of-type(2) {
        opacity: 0;
        transform: rotate(0deg) scale(0.2, 0.2);
      }

      span:nth-of-type(3) {
        transform: rotate(-45deg);
      }
    `}

  ${media.mobile`
    display: block;
  `}
`

const HamburgerButton = ({ isOpen, onClick }) => (
  <StyledHamburgerButton onClick={onClick} isOpen={isOpen}>
    <span />
    <span />
    <span />
  </StyledHamburgerButton>
)

export default HamburgerButton
